<template>
    <div class="o-crops">
        <div class="l-row m-card">
            <div class="l-row__column m-card__column">
                <div class="l-row m-card__container">
                    <m-control
                        :background-gray="true"
                        type="searchText"
                        label="Uprawy"
                        placeholder="Znajdź..."
                        name="crops"
                        model-name="crops"
                        @input="build('name', $event)"
                        :value="query['name']"
                    />
                </div>
            </div>
        </div>
        <o-list
            vuex-action-fetch="fetchCrops"
            vuex-action-fetch-next-page="fetchCropsNextPage"
            vuex-getter-model="crops"
            vuex-getter-status="cropsStatus"
            router-single-name="crop"
        >
            <template slot="list" slot-scope="props">
                <div class="m-list__itemPhoto">
                    <a-image
                        v-if="props.list.item.photos && props.list.item.photos.length > 0 && !!props.list.item.photos.find(item => item.is_main === true)"
                        :src="props.list.item.photos.find(item => item.is_main === true).full_uri"
                        :alt="props.list.item.name"
                    />
                    <a-icon
                        v-else
                        icon="Crops"
                    />
                </div>
                <p class="m-list__itemTitle m-list__itemTitle--margins">
                    {{ props.list.item.name }}
                </p>
                <div
                    class="m-list__itemIcons"
                    @click.stop="props.list.item.alerts_for_user && props.list.item.alerts_for_user.length > 0 ? showModal(props.list.item.alerts_for_user[0]) : false"
                >
                    <a-icon
                        v-if="props.list.item.alerts_for_user && props.list.item.alerts_for_user.length > 0"
                        class="m-list__icon"
                        icon="Notification"
                    />
                    <a-icon
                        v-else
                        class="m-list__icon"
                        icon="NotificationDisabled"
                    />
                </div>
            </template>
        </o-list>
        <o-modal name="alert">
            <a-icon icon="Agrofags" />
            <br />
            <p
                v-if="alertId"
                class="a-title a-title--small"
            >
                Alert {{ alertId }}
            </p>
            <br />
            <p>{{ alertDescription }}</p>
            <template v-slot:actions>
                <!-- <a-button class="a-button--smaller">Środki</a-button> -->
                <p></p>
                <a-button
                    v-if="alertId"
                    class="a-button--secondary a-button--icon a-button--smaller"
                    @click="modalClick()"
                >
                    Zobacz więcej
                    <a-icon icon="ArrowRight" class="a-button__icon a-button__icon--last"/>
                </a-button>
            </template>
        </o-modal>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Uprawy'
    },
    data() {
        return {
            alertId: null,
            alertDescription: ''
        }
    },
    computed: {
        query() {
            return this.$store.getters.cropsQuery
        }
    },
    methods: {
        build(name, value) {
            this.$store.dispatch('setCropsSearchQuery', {
                name,
                value
            }).then(() => {
                this.$store.dispatch('fetchCrops').catch(() => {})
            })
        },
        modalClick() {
            this.$router.push({ name: 'alert', params: { id: this.alertId } })
            this.$store.dispatch('modalHide')
        },
        showModal(alert) {
            this.alertId = alert.id
            this.alertDescription = alert.description
            this.$store.dispatch('modalShow', 'alert')
        }
    },
    created() {
        this.$store.dispatch('modalHide')
    }
}
</script>
